import { Input, InputProps } from "@evergis/ui";
import React, { FC } from "react";
import { FieldLabel, FieldPrefix, FieldWrapper } from "./styled";

export const Field: FC<InputProps> = ({ valuePrefix, label, ...props }) => {
  return (
    <FieldWrapper width={props.width} withLabel={!!label}>
      {label && <FieldLabel>{label}</FieldLabel>}
      {valuePrefix && <FieldPrefix>{valuePrefix}</FieldPrefix>}
      <Input {...props} />
    </FieldWrapper>
  );
};
